"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFinmoTimeRangeForTimeline = resolveFinmoTimeRangeForTimeline;
exports.resolveWalletExportFetchStep = resolveWalletExportFetchStep;
const wallet_export_constants_js_1 = require("./wallet-export.constants.js");
function resolveFinmoTimeRangeForTimeline(timeline) {
    if (!timeline || timeline === "all") {
        return {};
    }
    const match = /^(\d{4})-(\d{2})$/.exec(timeline.trim());
    if (!match) {
        return {};
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (month < 1 || month > 12) {
        return {};
    }
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 0, 23, 59, 59, 999);
    return {
        start_time: Math.floor(start.getTime() / 1000),
        end_time: Math.floor(end.getTime() / 1000),
    };
}
/**
 * Pagination stop / truncation rules for wallet PDF export Finmo fetch.
 * Truncation is only reported for "all time" exports.
 */
function resolveWalletExportFetchStep(input) {
    const maxRows = input.maxRows ?? wallet_export_constants_js_1.WALLET_EXPORT_MAX_ROWS;
    const isAllTime = !input.timeline || input.timeline === "all";
    const nextTotal = input.rowsSoFar + input.pageRowCount;
    if (nextTotal >= maxRows) {
        return { stop: true, truncated: isAllTime, rowCap: maxRows };
    }
    if (!input.pageRowCount || input.pageRowCount < input.pageSize) {
        return { stop: true, truncated: false };
    }
    if (input.page + 1 > input.maxPages) {
        return { stop: true, truncated: isAllTime };
    }
    return { stop: false, truncated: false };
}
